import { render, staticRenderFns } from "./ScrapView.vue?vue&type=template&id=49dbe5b8&scoped=true"
import script from "./ScrapView.vue?vue&type=script&lang=js"
export * from "./ScrapView.vue?vue&type=script&lang=js"
import style0 from "./ScrapView.vue?vue&type=style&index=0&id=49dbe5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dbe5b8",
  null
  
)

export default component.exports